module.exports = __webpack_public_path__ + "img/logo.b25bac39.png";